import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/shared/services/storage.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

	private baseUrl = 'https://legasys.top/itat/';

	// Declare the user property to hold credentials
	public user: any = null;

		constructor(
		private http: HttpClient,
		private storageService: StorageService,
		private router: Router
	) {
		this.initializeUser();
	}

	/**
	 * Checks if there is a stored login in the storageService.
	 * If found, assigns it to the user property and navigates to /board.
	 */
	async initializeUser() {
		try {
			const storedUser = await this.storageService.getFromStorage('user');
			if (storedUser) {
				this.user = storedUser;
				this.router.navigate(['/board'], { replaceUrl: true });
			}
			if (!storedUser) {
				this.router.navigate(['/']);
			}
		} catch (error) {
			console.error('Error retrieving stored user', error);
			this.router.navigate(['/']);
		}
	}

	login(email: string, password: string): Observable<any> {
		const endpoint = `${this.baseUrl}login.php`;
		const body = { email, password };
		return this.http.post(endpoint, body);
	}

	/**
	 * Remove the user from the storage, clear the user property
	 * and navigate to the login page.
	 */
	logout() {
		this.storageService.removeFromStorage('user');
		this.user = null;
		this.router.navigate(['/'], { replaceUrl: true });
	}

}
